import PropTypes from 'prop-types';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import TextInput from '../../../common/inputs/text-input/TextInput';
import Button from '../../../common/button/Button';

import './recover-password.scss';

const RecoverPassword = ({ submitEmail }) => {
  const [email, setEmail] = useState('');
  const [emailSuccess, setEmailSuccess] = useState(false);

  const navigate = useNavigate();

  const handleSubmitEmailClick = () => {
    submitEmail(email, setEmailSuccess);
  };

  return (
    <section className="recover-password">
      {emailSuccess ? (
        <section className="recover-password__success">
          <h1 className="recover-password__heading">Thank you.</h1>
          <p className="recover-password__text">Please check your inbox for further instructions.</p>
          <Button onClick={() => navigate('/')}>Return</Button>
        </section>
      ) : (
        <section className="recover-password__form">
          <h1 className="recover-password__heading">Recover Password</h1>
          <p className="recover-password__text">Please enter the email address associated with your account:</p>

          <TextInput
            name="email"
            placeholder="Email"
            value={email}
            onChange={({ target }) => setEmail(target.value)}
            type="email"
            auth
          />

          <div className="recover-password__button-container">
            <Button onClick={() => navigate('/')}>Back</Button>
            <Button onClick={handleSubmitEmailClick} disabled={!email}>
              Reset Password
            </Button>
          </div>
        </section>
      )}
    </section>
  );
};

RecoverPassword.propTypes = {
  resetPassword: PropTypes.func.isRequired,
};

export default RecoverPassword;
